export const PARTIES = {
  D: 'Democratic',
  R: 'Republican',
  G: 'Green'
};

export const NEIGHBORHOODS = {
  d1: 'Lower Manhattan',
  d2: 'East Village to Murray Hill',
  d4: 'East Side and Midtown',
  d6: 'Upper West Side',
  d8: 'East Harlem and South Bronx',
  d9: 'Harlem',
  d13: 'Northeast Bronx',
  d14: 'Morris Heights to Kingsbridge',
  d18: 'Clason Point to Parkchester',
  d20: 'Flushing and Murray Hill',
  d21: 'East Elmhurst and Corona',
  d28: 'Rochdale and South Ozone Park',
  d35: 'Clinton Hill to Crown Heights',
  d38: 'Red Hook and Sunset Park',
  d40: 'Prospect Lefferts Gardens to Kensington',
  d41: 'Ocean Hill to East Flatbush',
  d43: 'Bay Ridge to Bath Beach',
  d49: 'North Shore of Staten Island',
};

export const BOROS = {
  BRONX: 'Bronx County',
  BROOKLYN: 'Kings County',
  MANHATTAN: 'New York County',
  QUEENS: 'Queens County',
  STATEN_ISLAND: 'Richmond County'
};

export const DISTRICTS = {
  [BOROS.BRONX]: [8, 11, 12, 13, 14, 15, 16, 17, 18],
  [BOROS.BROOKLYN]: [33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48],
  [BOROS.MANHATTAN]: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  [BOROS.QUEENS]: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 34],
  [BOROS.STATEN_ISLAND]: [49, 50, 51]
};



// WEBPACK FOOTER //
// ./app/src/js/lib/lookup-tables.js